import * as SrvgCore from '@gaming/srvg-classes-core';
import * as Vf from './VfModule';
import * as VfWidgets from './widgets/VfWidgetLibrary';
import initGlobalFunctions from './globalFunctions/globalFunctions';

import { DesktopApp } from "./vf/App/DesktopApp";

const DebugView = Vf.DebugView;

$( function() {
    'use strict';
    (function ($, srvg) {
        initGlobalFunctions();
        // Globally set jquery animation tick to 50ms instead of the default 13ms for smoother jquery animations
        jQuery.fx.interval = 50;
        (window as any).Srvg = SrvgCore;
        (window as any).Vf = Vf;
        (window as any).Widgets = SrvgCore;
        (window as any).VfWidgets = VfWidgets;
        srvg.config = srvg.config || {};

        // Init widget loader
        srvg.widgetLoader = null;
        try {
            if (srvg.widgets.enabled) {
                srvg.widgetLoader = (window as any).vswidgets.init({});

                // Odds overrides
                // To have decimal seperator and work with different odds types for customer
                srvg.widgetLoader.setOddsOverrideHandler(function (metaInfo, oddsSuggestions, callback) {
                    for (var i = 0; i < oddsSuggestions.length; ++i) {
                        // round odds to 1 decimal place
                        oddsSuggestions[i].odds = srvg.oddsconversion.convertOdds(oddsSuggestions[i].odds);
                    }
                    callback(oddsSuggestions);
                });
            }
        }catch(e){
            console.error(
                "Widget loader doesn't work. Please check whether widgets are available. " +
                "If the widgets are available, please check the setOddsOverrideHandler. ");
        }
        
        // Init VF app
        app = new DesktopApp( {
            name: 'web-league',
            revision: 'VFC $Rev$',
            currentChannel: srvg.videooptions.defaultchannel || 0,
            templatesUrl: srvg.url.desktopTemplates,

            inactivityController: true
        } );


        // Debug toolbox, for debug possibilities
        srvg.debugView = new DebugView( { selector: '#srvgdebugbox' } );
    }( $, srvg ));
});